<template>
    <section class="musthave-section">
        <div class="container">

            <div class="section-header">
                <h2 class="section-title">Explore All {{ title }} Toolkits</h2>
            </div>

            <div class="musthave-grid">
                <a
                    v-for="product in items"
                    :key="product.id"
                    :href="baseURL + '/product/' + product.slug"
                    class="product-item"
                >
                    <div class="product-item__icon" :class="'bg-' + slug" :style="[
                        (product.image_thumb || product.image_path) ? 'padding:0;overflow:hidden;' : '',
                        product.category_gradient ? 'background:' + product.category_gradient : '',
                    ]">
                        <img v-if="product.image_thumb" :src="product.image_thumb" :alt="product.name">
                        <img v-else-if="product.image_path" :src="product.image_path" :alt="product.name">
                        <span v-else>{{ product.emoji || '📦' }}</span>
                    </div>
                    <div class="product-item__text">
                        <h4>{{ product.name }}</h4>
                        <p>{{ formatMoney( product.sale_price ) }}</p>
                    </div>
                    <span class="product-item__action">View</span>
                </a>
            </div>

            <div v-if="loading" class="cat-products-loading">
                <span></span><span></span><span></span>
            </div>

            <div ref="sentinel" class="cat-products-sentinel"></div>

        </div>
    </section>
</template>

<script>
export default {
    name: 'CategoryProducts',

    props: {
        slug  : { type: String, required: true },
        title : { type: String, required: true },
    },

    data() {
        return {
            items       : [],
            page        : 1,
            limit       : 24,
            total       : 0,
            loading     : false,
            hasMore     : true,
            initialized : false,   // флаг - первый запрос завершён
            observer    : null,
            baseURL     : window.baseURL || '',
        };
    },

    async mounted() {
        // Первый запрос ОБЯЗАТЕЛЬНО до observer
        await this.loadProducts();
        this.initialized = true;
        this.initObserver();
    },

    beforeUnmount() {
        if (this.observer) this.observer.disconnect();
    },

    methods: {

        async loadProducts() {
            if( this.loading || !this.hasMore )
                return;

            this.loading = true;
            try {
                const response = await this.$http.get('/products/list', {
                    params : {
                        category : this.slug,
                        page     : this.page,
                        limit    : this.limit,
                    }
                });
                const { status, data } = response?.data || {};

                if( status === 'success' ) {
                    this.items   = [...this.items, ...(data.items || [])];
                    this.total   = data.total || 0;
                    this.hasMore = this.items.length < this.total;

                    this.page++;
                }
            } catch (e) {
                console.error('Failed to load products:', e);
            } finally {
                this.loading = false;
            }
        },

        initObserver() {
            this.observer = new IntersectionObserver(
                (entries) => {
                    // Не дёргаем пока первый запрос не завершён
                    if( ! this.initialized )
                        return;

                    if( entries[0].isIntersecting && ! this.loading && this.hasMore )
                        this.loadProducts();
                },
                {rootMargin: '200px'}
            );

            this.$nextTick(() => {
                if (this.$refs.sentinel)
                    this.observer.observe(this.$refs.sentinel);
            });
        },

        formatMoney( cents ) {
            if( ! cents )
                return '';

            return new Intl.NumberFormat('en-US', {
                style    : 'currency',
                currency : 'USD',
            }).format( cents / 100 );
        },
    },
};
</script>